import { RootAppState } from 'store/configureStore'

export const projectIdSelector = (state: RootAppState) => {
  return state.project.activeProject?.id
}
